@import '../../../theme.scss';

// See https://www.kallmanation.com/styling-a-checkbox-with-only-css
verdocs-field-checkbox {
  padding: 0;
  width: 16px;
  height: 16px;
  display: block;
  scroll-margin: 20px 0;
  box-sizing: border-box;
  transform-origin: bottom left;
  font-family: $verdocs-primary-font;

  // To avoid conflicting with the use of a label for the checkbox itself
  div.label {
    top: -14px;
    left: -1px;
    height: 14px;
    color: white;
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #4a4a99;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  label {
    // This is needed to bring down the cursor from the parent element, which is where interactjs applies it
    cursor: inherit;

    width: 14px;
    height: 14px;
    display: block;
    box-sizing: border-box;
  }

  &.disabled label {
    opacity: 0.5;
  }

  label > input[type='checkbox'] {
    display: none;
  }

  label > input[type='checkbox'] + *::before {
    margin: 0;
    content: '';
    width: 12px;
    height: 12px;
    display: block;
    line-height: 12px;
    border-radius: var(--verdocs-field-radius);
    box-sizing: border-box;
    border: 1px solid $verdocs-grey-2;
  }

  label > input[type='checkbox']:checked + * {
    color: $verdocs-green;
  }

  label > input[type='checkbox']:checked + *::before {
    content: '✓';
    color: white;
    font-size: 12px;
    text-align: center;
    background: $verdocs-green;
    border-color: $verdocs-green;
  }

  &.required {
    border: 1px solid var(--verdocs-required-field-border);
  }

  &.hide {
    display: none;
  }

  verdocs-button-panel {
    display: block;
    margin-left: -20px;
    margin-top: -17px;
    transform: scale(0.7);
  }

  .settings-icon {
    position: absolute;
    top: -5px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }
}
